import { render, staticRenderFns } from "./DashboardDelivery.vue?vue&type=template&id=c9635006&scoped=true&"
import script from "./DashboardDelivery.vue?vue&type=script&lang=js&"
export * from "./DashboardDelivery.vue?vue&type=script&lang=js&"
import style0 from "../InputPPM/DashboardPPCM.scss?vue&type=style&index=0&id=c9635006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9635006",
  null
  
)

export default component.exports